/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import WyAgentOptimization from '../components/optimization/wy-va-optimization-page.vue'
import WyPerformanceComparison from '../components/optimization/wy-va-optimization-comparison.vue'
import WyIntentPerformance from '../components/optimization/wy-va-intent-performance.vue'
import WyResponsePerformance from '../components/optimization/wy-va-optimization-response-performance-page.vue'
import WyUnclassifiedMessages from '../components/optimization/wy-va-optimization-unclassified-messages.vue'
import WyFlows from '../components/optimization/wy-flow.vue'

export default [
  {
    path: '/optimization/agentOptimizationPage',
    name: 'agentOptimization',
    component: WyAgentOptimization,
    meta: { 
      bindModel: 'chat-analytics',
      filterAction: 'fetchChatFilters',
      filterNames: ['date', 'custTypes', 'languages'],
      headerMenuItems: [
        {name:'date-widget', properties:{disableToday: true}},
        {name:'brands-widget'},
        {name:'platform-dropdown-widget'},
        {name:'filtering-widget'}
      ]
    }
  },
  {
    path: '/optimization/performanceComparison',
    name: 'performanceComparison',
    component: WyPerformanceComparison,
    meta: { 
      bindModel: 'chat-analytics',
      filterAction: 'fetchChatFilters',
      filterNames: ['date', 'custTypes', 'languages'],
      headerMenuItems: [
        {name:'date-widget', properties:{disableToday: true}},
        {name:'brands-widget'},
        {name:'platform-dropdown-widget'},
        {name:'filtering-widget'}
      ]
    }
  },
  {
    path: '/optimization/responsePerformance',
    name: 'responsePerformance',
    component: WyResponsePerformance,
    meta: { 
      bindModel: 'chat-analytics',
      filterAction: 'fetchChatFilters',
      filterNames: ['date', 'custTypes', 'languages'],
      headerMenuItems: [
        {name:'date-widget', properties:{disableToday: true}},
        {name:'brands-widget'},
        {name:'platform-dropdown-widget'},
        {name:'filtering-widget'}
      ]
    }
  },
  {
    path: '/optimization/intentPerformance',
    name: 'intentPerformance',
    component: WyIntentPerformance,
    meta: { 
      bindModel: 'chat-analytics',
      filterAction: 'fetchChatFilters',
      filterNames: ['date', 'languages'],
      headerMenuItems: [
        {name:'date-widget', properties:{disableToday: true}},
        {name:'brands-widget'},
        {name:'filtering-widget'}
      ]
    }
  },
  {
    path: '/optimization/unclassifiedMessages',
    name: 'unclassifiedMessages',
    component: WyUnclassifiedMessages,
    meta: { 
      bindModel: 'chat-analytics',
      filterAction: 'fetchChatFilters',
      filterNames: ['date', 'custTypes', 'languages'],
      headerMenuItems: [
        {name:'date-widget', properties:{disableToday: true}},
        {name:'brands-widget'},
        {name:'platform-dropdown-widget'},
        {name:'filtering-widget'}
      ]
    }
  },
  {
    path: '/optimization/flows',
    name: 'flows',
    component: WyFlows,
    meta: { 
      bindModel: 'flows',
      filterAction: 'fetchFlowsFilters',
      filterNames: ['date', 'custTypes', 'languages'],
      headerMenuItems: [
        {name:'date-widget', properties:{disableToday: true}},
        {name:'brands-widget'},
        {name:'platform-dropdown-widget'},
        {name:'filtering-widget'}
      ]
    }
  }
]

